import { useDocumentData, useDocumentDataOnce } from 'react-firebase-hooks/firestore';
import { defaultCollOptions, user } from '../utils/collections';
import { fireAuth, handleDocument, onHandleSnapshot } from '../utils/firebase';

export const createUser = (userID, data) => user(userID).set(data);
export const getUser = (userID) => user(userID).get().then(handleDocument);
export const updateUser = (userID, data) => user(userID).update(data);
export const onUser = (userID, fn) => user(userID).onSnapshot(onHandleSnapshot(fn, handleDocument));
export const updateSelfUser = (data) => updateUser(fireAuth.currentUser.uid, data);
export const getSelfUser = () => getUser(fireAuth.currentUser.uid);
export const onSelfUser = (fn) => onUser(fireAuth.currentUser.uid, fn);

export const useUserListen = (userID) => useDocumentData(user(userID), defaultCollOptions);
export const useGetUser = (userID) => useDocumentDataOnce(user(userID), defaultCollOptions);
